/**
 * “Sets by muscle groups” bar scale: global max of (musclePrimary + muscleSecondary) across all weeks and rows.
 *
 * @param {ReadonlyArray<{ muscles?: { primary?: number, secondary?: number }[] }>} weeks
 * @returns {number} scale reference, at least `1`
 */
export function computeMuscleBarGlobalMax(weeks) {
  let max = 1;
  for (const w of weeks ?? []) {
    for (const row of w?.muscles ?? []) {
      const p = Number(row?.primary);
      const s = Number(row?.secondary);
      const musclePrimary = Number.isFinite(p) ? Math.max(0, p) : 0;
      const muscleSecondary = Number.isFinite(s) ? Math.max(0, s) : 0;
      const total = musclePrimary + muscleSecondary;
      if (total > max) {
        max = total;
      }
    }
  }
  return max;
}

/**
 * Overlay stack: outer width `totalPct` = (musclePrimary + muscleSecondary) / globalMax × 100 of the track.
 * Secondary layer fills the stack (transparent hue); primary solid strip is left portion `musclePrimary / rowTotal` of the stack.
 *
 * @param {number} musclePrimary
 * @param {number} muscleSecondary
 * @param {number} globalMax
 * @returns {{ totalPct: number, primaryShareOfStackPct: number, rowTotal: number }}
 */
export function muscleBarStackLayout(musclePrimary, muscleSecondary, globalMax) {
  const g = !Number.isFinite(globalMax) || globalMax <= 0 ? 1 : globalMax;
  const p = Number.isFinite(musclePrimary) ? Math.max(0, musclePrimary) : 0;
  const s = Number.isFinite(muscleSecondary) ? Math.max(0, muscleSecondary) : 0;
  const rowTotal = p + s;
  const totalPct = Math.min(100, (rowTotal / g) * 100);
  const primaryShareOfStackPct = rowTotal > 0 ? (p / rowTotal) * 100 : 0;
  return { totalPct, primaryShareOfStackPct, rowTotal };
}
